import request from '../../config/axiosConfig';
import { CREATE_POSITION_VIDEO, DELETE_POSITION_VIDEO, GET_LIST_POSITIONS_VIDEO, GET_POSITION_VIDEO_INFO, UPDATE_POSITION_VIDEO } from '../../constants/apiEndPoint';

export const getListPositionVideosRequest = async (data) => {
  const result = await request({
    url: GET_LIST_POSITIONS_VIDEO,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getPositionVideoInfoRequest = async (data) => {
    const result = await request({
      url: GET_POSITION_VIDEO_INFO,
      method: 'POST',
      data,
    });
    return result?.data.data;
  };
  
  export const createPositionVideoRequest = async (data) => {
    const result = await request({
      url: CREATE_POSITION_VIDEO,
      method: 'POST',
      data,
    });
    return result?.data;
  };
  
  export const updatePositionVideoRequest = async (data) => {
    const result = await request({
      url: UPDATE_POSITION_VIDEO,
      method: 'POST',
      data,
    });
    return result?.data;
  };
  
  export const deletePositionVideoRequest = async (data) => {
    const result = await request({
      url: DELETE_POSITION_VIDEO,
      method: 'POST',
      data,
    });
    return result?.data;
  };
